import React from 'react';

import NewPlatformInfoPage from '../components/NewPlatformInfoPage';

const NewPlatform = () => (
  <NewPlatformInfoPage
    lang="fr"
    title="Full Stack Open migre vers une nouvelle plateforme | Full Stack open"
  />
);

export default NewPlatform;
